import routerOptions0 from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/data/soft/jenkins/workspace/cocco-web-client-k8s-Pipeline-deploy/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}